import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../ui/card';
import { ChevronLeft } from 'lucide-react';

/**
 * Iter-46at: Shared layout for legal / policy pages (Terms, Refund, Privacy,
 * Cookies). Kept intentionally minimal — dense prose, clear headings, no
 * marketing chrome. Public and login-safe (no auth guard).
 */
export const PolicyLayout = ({ title, effectiveDate, lastUpdated, children }) => {
  return (
    <div className="min-h-screen bg-muted/30 py-8 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-6 transition-colors"
          data-testid="policy-back-link"
        >
          <ChevronLeft className="w-4 h-4" />
          Back to StudioScheduler
        </Link>
        <Card className="p-6 sm:p-10">
          <header className="mb-8 border-b pb-6">
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight" data-testid="policy-title">
              {title}
            </h1>
            <div className="mt-3 text-sm text-muted-foreground space-y-0.5">
              {effectiveDate && <p>Effective date: {effectiveDate}</p>}
              {lastUpdated && <p>Last updated: {lastUpdated}</p>}
            </div>
          </header>
          <div className="prose prose-slate max-w-none prose-headings:font-semibold prose-headings:tracking-tight prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3 prose-h3:text-base prose-h3:mt-5 prose-h3:mb-2 prose-p:text-sm prose-p:leading-relaxed prose-p:text-muted-foreground prose-li:text-sm prose-li:text-muted-foreground prose-strong:text-foreground prose-a:text-primary hover:prose-a:opacity-80">
            {children}
          </div>
        </Card>
        <div className="mt-6 text-center text-xs text-muted-foreground">
          Borrow A Geek Limited trading as StudioScheduler · 18 Henry Street, Kilrush, Co. Clare V15 CX71, Ireland
        </div>
      </div>
    </div>
  );
};

export default PolicyLayout;
